import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import { IUpdateItem } from 'service/type';
import React, { useEffect, useState } from 'react';
import ModalCart from '../modal-cart';
import { useDispatch } from 'react-redux';
import OrderAction from '../../../../redux/actions/order/orderAction';
import { toast } from 'react-toastify';

function ItemCart(props) {
    const {
        item,
        booked,
        isBooked,
        hideShowIcon
    } = props;
    const pw = localStorage.getItem('PW');
    const onHandleClose = () => {
        setShowComfirm(false);
    };
    // ==========================================================================
    // STATE
    // ==========================================================================
    const [showComfirm, setShowComfirm] = useState(false);
    const [password, setPassword] = useState('');
    const [note, setNote] = useState('');
    const [selectedItem, setSelectedItem] = useState(0);
    const [selectedIdParent, setSelectIdParent] = useState(0);

    //============================================================================
    // DISPATCH
    // ===========================================================================
    const dispatch = useDispatch();
    const _updateBookedList = (detailId: number, qty: number, flag: string, noteStr: string, parentId: number) => dispatch<any>(OrderAction.updateBookedList({ detailId: detailId, qty: qty, flag: flag, note: noteStr, parent_id: parentId }));
    const _updateOrderList = (item_id: number, qty: number, flag: string, noteStr: string, parentId: number) => dispatch<any>(OrderAction.updateOrderList({ item_id: item_id, qty: qty, flag: flag, note: noteStr, parent_id: parentId }));
    const _removeItemsFromCart = (item_id: number, menu_id: number, parentId: number) => dispatch<any>(OrderAction.removeItemsFromCart({ item_id: item_id, menu_id: menu_id, parent_id: parentId }));
    const _removeItemBookedList = (detailId: number, parentId: number) => dispatch<any>(OrderAction.removeItemBookedList({ detailId: detailId, parent_id: parentId }));
    // =============================
    //  COMMON
    // =============================
    const formatMoney = (number) => {
        if (typeof number === 'number') {
            // Sử dụng toLocaleString để định dạng tiền tệ
            return number.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' });
        }
        return number;
    };
    // =============================
    // EVENTS HANDERS
    // =============================
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const handleConfirmDeleteItem = async (note) => {
        if (note === '') {
            toast.error('Vui lòng nhập note!', {
                position: 'top-right',
                theme: 'colored'
            });
        }
        else {
            _removeItemBookedList(selectedItem, selectedIdParent);
            setNote('');
            setPassword('');
            setShowComfirm(false);
            onHandleClose();
            toast.success('Xóa món thành công', {
                position: 'top-right',
                theme: 'colored'
            });
        }

    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const handleUpdateQuantity = async (body: IUpdateItem, type, item) => {
        if (isBooked) {
            if (body.qty < 1) {
                _updateBookedList(body.detailId, body.qty, 'DELETE', item.note, item.parent_id);
            }
            else {
                _updateBookedList(body.detailId, body.qty, 'UPDATE', item.note, item.parent_id);
            }
        }
        else {
            if (body.qty < 1) {
                // _updateOrderList(item.item_id,body.qty,'DELETE');
                _removeItemsFromCart(item.item_id, item.menu_id, item.parent_id);
            }
            else {
                _updateOrderList(item.item_id, body.qty, null, '', item.parent_id);
            }
        }
    };
    const handleChangeNote = (noteStr: string) => {
        setNote(noteStr);
        _updateBookedList(item.detailId, item.qty, 'UPDATE', noteStr, item.parent_id);
        _updateOrderList(item.item_id, item.qty, 'UPDATE', noteStr, item.parent_id);
    };
    const handleRemoveItem = async (cartItem: any) => {

        if (isBooked) {
            setSelectedItem(cartItem.detailId);
            setSelectIdParent(cartItem.parent_id);
            setShowComfirm(true);
        }
        else {
            _removeItemsFromCart(cartItem.item_id, cartItem.menu_id, item.parent_id);
        }
    };

    return (
        <div className="item">
            <div className="main-item">
                <div className="item-info">
                    <img src={item?.image || '../../../assets/icon/DefaultImageMeal/index.svg'} style={{ width: 50, height: 50, borderRadius: 4 }} alt="can't load" />
                    <div>
                        <div className="font-big" style={{ marginBottom: 7, opacity: isBooked ? 0.6 : 1 }}>{item?.label || item?.itemName}</div>
                        <div className="font-normal">{formatMoney(item?.price)}</div>
                    </div>
                </div>
                <div className="item-value">
                    <div className='item-quantity' style={{ marginBottom: 10, justifyContent: hideShowIcon ? 'flex-end' : 'space-between' }}>
                        {!hideShowIcon ?
                            <div style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    handleUpdateQuantity({
                                        detailId: item.detailId,
                                        qty: item.qty - 1
                                    }, 'minus', isBooked ? item.detailId : item);
                                }}
                            >
                                <RemoveIcon fontSize='small'
                                    style={{
                                        border: '1.33px solid #CAA37D',
                                        borderRadius: 4
                                    }} />
                            </div> : null}

                        <span className='font-big'>{hideShowIcon ? 'X' : ''}{item.quantity || item?.qty}</span>

                        {!hideShowIcon ?
                            <div style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    handleUpdateQuantity({
                                        detailId: item.detailId,
                                        qty: item.qty + 1
                                    }, 'plus', item);
                                }}
                            >
                                <AddIcon fontSize='small'
                                    style={{
                                        background: '#CAA37D',
                                        color: 'white',
                                        borderRadius: 4
                                    }} />
                            </div> : null
                        }
                    </div>
                    <div className='font-big' style={{ textAlign: 'right' }}>{formatMoney(item?.price * item?.qty)}</div>
                </div>
            </div>

            <div className="note">
                <>
                    <div className='note-label' style={{ marginTop: 5, opacity: 1, borderBottom: '1px solid #B98868', display: 'flex' }}>
                        <SVGNoteCart />
                        <span style={{ color: '#B98868', marginLeft: 6 }}>Note:</span>
                        <hr style={{ margin: 0 }}></hr>
                    </div>
                    <textarea rows={1}
                        className='font-normal note-style'
                        placeholder='no note'
                        value={item?.note || note}
                        onChange={(e) => handleChangeNote(e.target.value)}
                        defaultValue={item?.note} />
                </>
                {!hideShowIcon ? <div className='note-icon'>
                    <div onClick={() => {
                        handleRemoveItem(item);
                    }}>
                        <SVGDeleteCart />
                    </div>
                </div> : null}
            </div>
            <ModalCart
                show={showComfirm}
                onHandleClose={onHandleClose}
                onConfirm={handleConfirmDeleteItem}
                password={password}
                setPassword={setPassword}
                note={note}
                setNote={setNote}
            />
        </div>
    );

}


export default ItemCart;

export const SVGNoteCart = () => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.66997 13.7763H4.52263C2.51538 13.7763 1.16672 12.3676 1.16672 10.2711V5.42127C1.16672 3.32477 2.51538 1.91602 4.52263 1.91602H6.70372C6.94522 1.91602 7.14122 2.11202 7.14122 2.35352C7.14122 2.59502 6.94522 2.79102 6.70372 2.79102H4.52263C3.0153 2.79102 2.04172 3.82352 2.04172 5.42127V10.2711C2.04172 11.8688 3.0153 12.9013 4.52263 12.9013H9.66997C11.1773 12.9013 12.1515 11.8688 12.1515 10.2711V7.92143C12.1515 7.67993 12.3475 7.48393 12.589 7.48393C12.8305 7.48393 13.0265 7.67993 13.0265 7.92143V10.2711C13.0265 12.3676 11.6772 13.7763 9.66997 13.7763Z" fill="#B98868" />
            <path fillRule="evenodd" clipRule="evenodd" d="M5.17282 9.72778H6.90941C7.13107 9.72778 7.33874 9.64202 7.49566 9.48511L11.8759 5.10486C12.0556 4.92519 12.1547 4.68603 12.1547 4.43169C12.1547 4.17678 12.0556 3.93703 11.8759 3.75736L11.166 3.04744C10.7944 2.67703 10.1901 2.67703 9.81791 3.04744L5.45866 7.40669C5.30757 7.55778 5.22182 7.75844 5.21657 7.97136L5.17282 9.72778ZM6.90941 10.6028H4.72424C4.60641 10.6028 4.49324 10.5549 4.41099 10.4704C4.32874 10.3864 4.28382 10.2726 4.28674 10.1542L4.34157 7.94978C4.35266 7.51111 4.52941 7.09869 4.83974 6.78778H4.84032L9.19957 2.42853C9.91241 1.71686 11.0715 1.71686 11.7843 2.42853L12.4942 3.13844C12.8402 3.48378 13.0303 3.94286 13.0297 4.43169C13.0297 4.92053 12.8396 5.37903 12.4942 5.72378L8.11399 10.104C7.79257 10.4254 7.36441 10.6028 6.90941 10.6028Z" fill="#B98868" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.5097 6.51257C11.3977 6.51257 11.2857 6.46999 11.2006 6.38424L8.53708 3.72074C8.36616 3.54982 8.36616 3.27274 8.53708 3.10182C8.70799 2.9309 8.98449 2.9309 9.15541 3.10182L11.8189 5.7659C11.9898 5.93682 11.9898 6.21332 11.8189 6.38424C11.7337 6.46999 11.6217 6.51257 11.5097 6.51257Z" fill="#B98868" />
        </svg>
    );
};

export const SVGDeleteCart = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.2055 19.0614C9.07635 19.0614 7.97552 19.0489 6.88635 19.0264C5.49302 18.9989 4.52885 18.0955 4.37135 16.6689C4.10885 14.3022 3.65969 8.72386 3.65552 8.66802C3.62719 8.32386 3.88385 8.02219 4.22802 7.99469C4.56719 7.98552 4.87385 8.22386 4.90135 8.56719C4.90552 8.62386 5.35385 14.183 5.61385 16.5314C5.70302 17.3422 6.14052 17.7605 6.91219 17.7764C8.99552 17.8205 11.1214 17.823 13.413 17.7814C14.233 17.7655 14.6764 17.3555 14.768 16.5255C15.0264 14.1972 15.4764 8.62386 15.4814 8.56719C15.5089 8.22386 15.813 7.98386 16.1539 7.99469C16.498 8.02302 16.7547 8.32386 16.7272 8.66802C16.7222 8.72469 16.2705 14.3172 16.0105 16.663C15.8489 18.1189 14.8872 19.0047 13.4355 19.0314C12.3247 19.0505 11.253 19.0614 10.2055 19.0614Z" fill="#B51929" />
            <path fillRule="evenodd" clipRule="evenodd" d="M17.2567 6.55244H3.125C2.78 6.55244 2.5 6.27244 2.5 5.92744C2.5 5.58244 2.78 5.30244 3.125 5.30244H17.2567C17.6017 5.30244 17.8817 5.58244 17.8817 5.92744C17.8817 6.27244 17.6017 6.55244 17.2567 6.55244Z" fill="#B51929" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14.5337 6.55244C13.5853 6.55244 12.762 5.87661 12.5753 4.94661L12.3728 3.93328C12.3303 3.77911 12.1545 3.64494 11.9545 3.64494H8.42701C8.22701 3.64494 8.05117 3.77911 8.00034 3.97161L7.80617 4.94661C7.62034 5.87661 6.79617 6.55244 5.84784 6.55244C5.50284 6.55244 5.22284 6.27244 5.22284 5.92744C5.22284 5.58244 5.50284 5.30244 5.84784 5.30244C6.20284 5.30244 6.51117 5.04911 6.58117 4.70078L6.78367 3.68744C6.98951 2.91078 7.66201 2.39494 8.42701 2.39494H11.9545C12.7195 2.39494 13.392 2.91078 13.5895 3.64994L13.8012 4.70078C13.8703 5.04911 14.1787 5.30244 14.5337 5.30244C14.8787 5.30244 15.1587 5.58244 15.1587 5.92744C15.1587 6.27244 14.8787 6.55244 14.5337 6.55244Z" fill="#B51929" />
        </svg>

    );
};
